import { TReportState } from '@/redux/reducers/report';
import { TGetReportOrdersSuccess } from '@/redux/actions/report';

export const getReportOrdersUpdateState = (state: TReportState, action: TGetReportOrdersSuccess): TReportState => ({
  ...state,
  getReportOrdersResponse: action.payload.response,
});
